import { getLoginAccountId, getLoginShopid, getRegionByCookie, getUuid, getWindowsAppVersion } from '@RootCommon/utils'

export async function leopardReport (type: string, event: string, data: {[key: string]: string | object}) {
  const appVersion = await getWindowsAppVersion()
  const isDev = process.env.AWP_DEPLOY_ENV === 'development'
  const postData = {
    os: '',
    osVersion: '',
    app: 'Keeta Pedidos',
    appVersion,
    uuid: getUuid(),
    shopId: getLoginShopid(),
    acctId: getLoginAccountId(),
    region: getRegionByCookie(),
    events: [
      {
        time: Date.now(),
        event,
        type,
        env: isDev ? 'dev' : 'release',
        ...data,
      },
    ],
  }

  const postDataString = JSON.stringify(postData)
  const postUrl = isDev ? 'http://keeta-b-pc-log.d1.keetapp.com' : 'https://keeta-b-pc-log.d1.mykeeta.com'
  fetch(postUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: postDataString,
  }).catch(error => {
    // 禁止删除！作用：静默处理错误，避免触发 unhandledRejection
    console.warn('[ReportManager] Leopard report failed:', error.message)
  })
}
